import { TableColumn } from "@/components/Table/Table";

import { SortParams } from "@/types/types";

import {
	renderCompanyCategoryColumn,
	renderCompanyCityColumn,
	renderCompanyColumn,
	renderCompanyCountryColumn,
	renderCompanyStateColumn,
	renderDeepResearchStatusColumn,
	renderEstimatedNumEmployeesColumn,
	renderIndustryColumn,
	renderReportedEmployeesColumn,
	renderScoreColumn,
	renderSelectColumn,
	renderSignalColumn,
	renderTrackerPersonsColumn,
} from "../utils/allColumns";

import { TrackerOrganization } from "../schema/trackerOrganizations";

export interface GeneralTableColumnsProps {
	selectAll: boolean;
	toggleSelectAll: () => void;
	selectedItems: number[];
	handleSelectItem: (id: number) => void;
	handleCopyClick: (value: string) => void;
	// handleContextMenu: (value: string, row: ListPerson) => void;
	ts: (key: string) => string;
	sortingInbox: SortParams;
	setShowEdit: ({ id, name }: { id: number; name: string }) => void;
	showEdit: { id: number; name: string } | undefined;
	onPersonClick?: (trackerOrganizationId: number, personId: number) => void;
	onResearchClick?: (row: TrackerOrganization) => void;
	/**
	 * Does the tracker's list have a signal config? Drives the "Looking for signals" state of the
	 * Signal column (PREC-3616). Resolved once per table, never per row.
	 */
	signalsConfigured: boolean;
}

export const GeneralTableColumns = ({
	selectAll,
	toggleSelectAll,
	selectedItems,
	handleSelectItem,
	handleCopyClick,
	// handleContextMenu,
	ts,
	sortingInbox,
	setShowEdit,
	showEdit,
	onPersonClick,
	onResearchClick,
	signalsConfigured,
}: GeneralTableColumnsProps): TableColumn[] => {
	return [
		renderSelectColumn(toggleSelectAll, selectAll, selectedItems, handleSelectItem),
		renderCompanyColumn(ts, handleCopyClick, sortingInbox, setShowEdit, showEdit),
		renderTrackerPersonsColumn(ts, onPersonClick),
		renderSignalColumn(ts, signalsConfigured),
		renderDeepResearchStatusColumn(onResearchClick),
		renderCompanyCategoryColumn(ts, handleCopyClick, sortingInbox),
		renderEstimatedNumEmployeesColumn(ts, handleCopyClick, sortingInbox),
		renderReportedEmployeesColumn(ts, handleCopyClick, sortingInbox),
		renderCompanyCountryColumn(ts, handleCopyClick, sortingInbox),
		renderCompanyStateColumn(ts, handleCopyClick, sortingInbox),
		renderCompanyCityColumn(ts, handleCopyClick, sortingInbox),
	];
};
